import { Component, OnInit } from '@angular/core';
import { PROJECTS } from 'src/assets/json/user-info';
import { of } from 'rxjs';
import { DataService } from 'src/app/services/data.service';
import { Projects } from '../../../mock/Projects.mockdata'
import { IProject } from 'src/app/Models/interfaces/IProject';


@Component({
  selector: 'app-projects',
  templateUrl: './projects.component.html',
  styleUrls: ['./projects.component.css']
})
export class ProjectsComponent implements OnInit {

  id: null;
  get projects(): any {
  return of(PROJECTS.filter(f => f.display === true));
  }

  get _projects(): IProject[] { return Projects; }

  constructor(private data: DataService) { }

  ngOnInit(): void {
  }
  showDetails(id): void {
    this.data.changeMessage(id);
    document.getElementById('rightSideBar').click();
  }


}
